import * as Yup from "yup";
import React from "react";
import FormDefault from "../../components/Forms/FormDefault";
import { Request } from "../../hooks/Request";
import { validateType } from "../../utils/constant";
import ProofDeliveryDocument from "./ProofDeliveryDocument";
import { useDialog } from "../../contexts/DialogContext";
import { requestAuth } from "../../components/services/RequestService";
import DocumentRequestPdf from "./DocumentRequestPdf";

const listFields = ["Documentosparalaconstanciadeentrega"];

export const FormDocumentsDeliver = (props) => {
  const { procedure } = props;

  const { openDialog } = useDialog();

  const { data, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/datasets?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });

  function dataFields(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]: element.validate
          ? validateType[element.type] || null
          : null,
      };
    });
    return aux;
  }

  function dataIntialValues(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]:
          (element.initial === "false" ? false : element.initial) || "",
      };
    });
    return aux;
  }

  async function onSubmit(values) {
    console.log("Valores del formulario DO:", values);

    const subdataResponse = await requestAuth(
      "get",
      `/dataSet/procedure/${procedure.id || procedure.procedureId}/field/${
        data[0].id
      }/subdata`
    );

    openDialog(<DocumentRequestPdf procedure={procedure} />);
    // <ProofDeliveryDocument
    //   procedure={{ ...procedure, id: procedure.procedureId }}
    //   documentData={subdataResponse.data} // Pasar los datos aquí
    // />
  }

  if (!loading) {
    return null;
  }

  return (
    <div>
      <FormDefault
        tittle="Formulario de Entrega de Documentos"
        fields={data.map((value, index) => ({
          ...value,
          id: procedure.id,
          fieldId: value.id,
          label: value.label,
          labelCustom: (
            <>
              <span className="text-green-600">{index + 1}.</span> {value.label}
            </>
          ),
          name: value.name,
          validate: value.validate,
          type: value.type,
          typeInput: value.type,
          initial: value.initial ? value.initial : null,
        }))}
        initialValues={dataIntialValues(data)}
        validationSchema={Yup.object().shape(dataFields(data))}
        onSubmit={onSubmit}
        buttonName="Guardar"
      />
    </div>
  );
};
